module.exports = __webpack_public_path__ + "static/media/exhibition-services-img1.d79ad5a3.jpg";